/* EYEKØNIK brillenkiezer: sections/eyk-finder.liquid. Questions and matching on the product JSON the section renders. */
(function () {
  'use strict';

  var MAX_RESULTS = 6;
  var MIN_RESULTS = 3;
  var STORE_KEY = 'eyk_finder_v2';
  // The route depends on who it is for: women start from the look and pick color with more nuance, men get a fit question.
  // This split is an assumption, not measured (Musa 4 Nov 2026); change the order here once there is data.
  var ROUTE = {
    women: ['who', 'style', 'face', 'widest', 'shape', 'colour'],
    men: ['who', 'style', 'face', 'widest', 'shape', 'fit', 'colour'],
    both: ['who', 'style', 'face', 'widest', 'shape', 'fit', 'colour']
  };
  var SKIP = { style: 'any', face: 'unsure', widest: 'unsure', shape: 'any', fit: 'ok', colour: 'none' };
  // Face and widest only rank; everything else filters. Weights rank the near matches.
  var WEIGHT = { who: 4, style: 3, shape: 3, fit: 1, colour: 1 };
  var WIDEST_FACE = { forehead: 'heart', cheeks: 'diamond', jaw: 'square', even: 'oval' };
  // Frame shapes that balance a face shape. Oval suits nearly everything, so it marks nothing.
  var SUITS = {
    round: ['square', 'geo', 'cat'],
    square: ['round', 'oval', 'aviator'],
    heart: ['round', 'oval', 'aviator'],
    diamond: ['cat', 'oval', 'round'],
    oval: []
  };

  // custom.face_shape and custom.frame_color are translated per language (sv and pt-PT today, others may follow),
  // and frame_color also holds both "Transparent" and "Transparant". Every word maps back to one canonical value here.
  var GENDER_WORDS = {
    men: 'men|man|mannen|heren|herren|männer|hommes|homme|hombres|hombre|uomini|uomo|män|herr|homens|homem',
    women: 'women|woman|vrouwen|dames|damen|frauen|femmes|femme|mujeres|mujer|donne|donna|kvinnor|dam|mulheres|mulher'
  };
  var FACE_WORDS = {
    oval: 'oval|ovaal|ovale|ovalada|ovalado',
    round: 'round|rond|rund|ronde|redonda|redondo|rotondo|rotonda',
    square: 'square|vierkant|eckig|quadratisch|carré|cuadrada|cuadrado|quadrato|squadrato|fyrkantig|quadrado|quadrada',
    heart: 'heart|hart|herz|cœur|coeur|corazón|cuore|hjärta|coração',
    diamond: 'diamond|diamant|diamante'
  };
  var COLOUR_WORDS = {
    dark: 'black|zwart|schwarz|noir|negro|nero|svart|preto|grey|gray|grijs|grau|gris|grigio|grå|cinzento|cinza',
    leopard: 'leopard|luipaard|léopard|leopardo|leopardato',
    light: 'transparent|transparant|transparente|trasparente|crystal|white|wit|weiß|weiss|blanc|blanco|bianco|vit|branco|beige|bege|creme|crème|krämvit|crema',
    brown: 'brown|bruin|braun|brun|marrón|marrone|castanho|orange|oranje|naranja|arancione|laranja',
    colour: 'blue|blauw|blau|bleu|azul|blu|blå|green|groen|grün|vert|verde|grön|red|rood|rot|rouge|rojo|rosso|röd|vermelho|turquoise|turkoois|türkis|turquesa|turchese|turkos|yellow|geel|gelb|jaune|amarillo|giallo|gul|amarelo|pink|roze|rosa|rose|purple|paars|lila|violet|violeta|viola',
    metal: 'gold|goud|or|oro|guld|dourado|silver|zilver|silber|argent|plata|plateado|argento|prateado|rose gold|rosé gold|rosegold|roségold|rose goud|or rose|oro rosa|roséguld|ouro rosa'
  };

  function dictionary(words) {
    var map = {};
    Object.keys(words).forEach(function (key) {
      words[key].split('|').forEach(function (w) { map[w] = key; });
    });
    return map;
  }
  var GENDER = dictionary(GENDER_WORDS);
  var FACE = dictionary(FACE_WORDS);
  var COLOUR = dictionary(COLOUR_WORDS);

  function canonical(raw, map) {
    var out = {};
    String(raw || '').split('|').forEach(function (w) {
      var key = map[w.trim().toLowerCase()];
      if (key) out[key] = true;
    });
    return out;
  }

  function readJson(root, attr, fallback) {
    var el = root.querySelector('[' + attr + ']');
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function matches(p, q, v) {
    if (q === 'who') {
      if (v === 'both') return !!(p.who.men && p.who.women);
      return !!p.who[v];
    }
    return !!p[q][v];
  }

  function flags(list) {
    var out = {};
    (list || []).forEach(function (v) { out[v] = true; });
    return out;
  }

  function init(root) {
    var quiz = root.querySelector('[data-eyk-quiz]');
    var res = root.querySelector('[data-eyk-res]');
    var grid = root.querySelector('[data-eyk-grid]');
    var lead = root.querySelector('[data-eyk-res-lead]');
    var back = root.querySelector('[data-eyk-back]');
    var progress = root.querySelector('[data-eyk-progress]');
    var allLink = root.querySelector('[data-eyk-all]');
    var restart = root.querySelector('[data-eyk-restart]');
    var intro = root.querySelector('.eyk-finder__intro');
    var text = readJson(root, 'data-eyk-text', {});
    var all = text.all || {};

    var frames = readJson(root, 'data-eyk-frames', {});
    var products = readJson(root, 'data-eyk-products', []).map(function (p, i) {
      var frame = frames[p.h] || {};
      return {
        rank: i, key: p.k, title: p.t, url: p.u, image: p.i, model: p.m, late: !!p.l,
        who: canonical(p.g, GENDER), face: canonical(p.f, FACE), colour: canonical(p.c, COLOUR),
        shape: flags(frame.s), style: flags(frame.y), fit: flags(frame.z)
      };
    });

    var answers = {};
    var path = [];
    var currentQ = 'use';

    function step(q) { return quiz.querySelector('[data-q="' + q + '"]'); }

    function audience() { return answers.who === 'women' ? 'women' : 'men'; }

    function order() { return ROUTE[answers.who] || ROUTE.both; }

    // Questions and options can be written for one audience only (data-for).
    function forAudience(el) { return !el.dataset.for || el.dataset.for === audience(); }

    function options(q) {
      return [].slice.call(step(q).querySelectorAll('[data-v]')).filter(forAudience).map(function (b) { return b.dataset.v; });
    }

    function isFilter(q) { return q !== 'face' && q !== 'widest'; }

    function faceAnswer() {
      if (answers.face && answers.face !== 'unsure') return answers.face;
      return WIDEST_FACE[answers.widest] || null;
    }

    function suits(p, face) {
      return (SUITS[face] || []).some(function (shape) { return p.shape[shape]; });
    }

    function shapeCount(items) {
      var seen = {};
      items.forEach(function (p) { Object.keys(p.shape).forEach(function (k) { seen[k] = true; }); });
      return Object.keys(seen).length;
    }

    function modelCount(items) {
      var seen = {};
      items.forEach(function (p) { seen[p.model] = true; });
      return Object.keys(seen).length;
    }

    // Everything that still fits the answers so far. By construction this never becomes empty:
    // an option is only offered when at least one product in the current pool has it.
    function pool() {
      return products.filter(function (p) {
        if (p.key !== answers.use) return false;
        return order().every(function (q) {
          var v = answers[q];
          return !isFilter(q) || !v || v === SKIP[q] || matches(p, q, v);
        });
      });
    }

    // The options that lead somewhere, or null when the answer could not change the outcome
    // (ski: all goggles carry the same gender and face values; blue light and running: same for face).
    function usable(q, items) {
      if (q === 'widest') return answers.face === 'unsure' && shapeCount(items) > 1 ? options(q) : null;
      if (q === 'face') return shapeCount(items) > 1 ? options(q) : null;
      var seen = {};
      var open = options(q).filter(function (v) {
        if (v === SKIP[q]) return false;
        var hit = items.filter(function (p) { return matches(p, q, v); });
        if (hit.length) seen[hit.map(function (p) { return p.rank; }).join(',')] = true;
        return hit.length > 0;
      });
      return Object.keys(seen).length < 2 ? null : open;
    }

    function nextQuestion(items, after) {
      var route = order();
      // Once a few models are left, more questions would only hide them. The first question always runs: it sets the route.
      if (after !== 'use' && modelCount(items) <= MIN_RESULTS) return null;
      for (var i = after === 'use' ? 0 : route.indexOf(after) + 1; i < route.length; i++) {
        if (usable(route[i], items)) return route[i];
      }
      return null;
    }

    function remaining(items, after) {
      var n = 0;
      var route = order();
      for (var i = after === 'use' ? 0 : route.indexOf(after) + 1; i < route.length; i++) {
        if (usable(route[i], items)) n++;
      }
      return n;
    }

    function hideAllSteps() {
      [].forEach.call(quiz.querySelectorAll('[data-q]'), function (s) { s.hidden = true; });
    }

    function focusAndReveal(el) {
      var top = root.getBoundingClientRect().top;
      if (top < 0 && root.scrollIntoView) root.scrollIntoView({ block: 'start' });
      var h = el.querySelector('[tabindex="-1"]:not([hidden])') || el;
      try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    }

    function paintChoice(q) {
      [].forEach.call(step(q).querySelectorAll('[data-v]'), function (b) {
        b.setAttribute('aria-pressed', b.dataset.v === answers[q] ? 'true' : 'false');
      });
    }

    function showQuestion(q, moveFocus) {
      currentQ = q;
      if (intro) intro.hidden = q !== 'use';
      res.hidden = true;
      quiz.hidden = false;
      hideAllSteps();
      var el = step(q);

      if (q === 'use') {
        [].forEach.call(el.querySelectorAll('[data-v]'), function (b) {
          b.hidden = !products.some(function (p) { return p.key === b.dataset.v; });
        });
        progress.textContent = '';
      } else {
        // Options are judged on the pool before this question is answered.
        var saved = answers[q];
        delete answers[q];
        var items = pool();
        if (saved) answers[q] = saved;
        var open = usable(q, items) || [];
        [].forEach.call(el.querySelectorAll('[data-v]'), function (b) {
          b.hidden = !forAudience(b) || (b.dataset.v !== SKIP[q] && open.indexOf(b.dataset.v) < 0);
        });
        [].forEach.call(el.querySelectorAll('[data-for]:not([data-v])'), function (h) { h.hidden = !forAudience(h); });
        if (q === 'shape') markShapes(el);
        var at = path.indexOf(q);
        var current = (at > -1 ? at : path.length) + 1;
        var total = current + remaining(items, q);
        progress.textContent = (text.step || '').replace('[current]', current).replace('[total]', total);
      }

      back.hidden = q === 'use';
      paintChoice(q);
      el.hidden = false;
      if (moveFocus) focusAndReveal(el);
    }

    // What the face answer changes in the next question: fitting shapes move up and get a label, the rest stays available.
    function markShapes(el) {
      var face = faceAnswer();
      [].forEach.call(el.querySelectorAll('[data-v]'), function (b) {
        var fits = !!face && (SUITS[face] || []).indexOf(b.dataset.v) > -1;
        b.classList.toggle('eyk-finder__opt--fits', fits);
        var label = b.querySelector('[data-eyk-fits]');
        if (label) label.hidden = !fits;
      });
    }

    function pickDistinct(list, shown, limit) {
      var models = {};
      shown.forEach(function (p) { models[p.model] = true; });
      list.forEach(function (p) {
        if (shown.length >= limit || models[p.model] || shown.indexOf(p) > -1) return;
        models[p.model] = true;
        shown.push(p);
      });
      return shown;
    }

    function pickAny(list, shown, limit) {
      list.forEach(function (p) {
        if (shown.length < limit && shown.indexOf(p) < 0) shown.push(p);
      });
      return shown;
    }

    function score(p) {
      return order().reduce(function (sum, q) {
        var v = answers[q];
        if (!isFilter(q) || !v || v === SKIP[q]) return sum;
        return sum + (matches(p, q, v) ? WEIGHT[q] : 0);
      }, 0) + faceScore(p);
    }

    // The face answer never removes a frame, it only moves the frames that suit it up.
    function faceScore(p) {
      var face = faceAnswer();
      if (!face) return 0;
      return (suits(p, face) ? 2 : 0) + (p.face[face] ? 1 : 0);
    }

    // Best face fit first, stock before late delivery, then best sellers (rank = list order).
    function byFit(a, b) {
      return faceScore(b) - faceScore(a) || (a.late ? 1 : 0) - (b.late ? 1 : 0) || a.rank - b.rank;
    }

    // One model per card first, so the visitor meets different models instead of six colors of one.
    // Variants of a model only come in when that is all there is, and near matches only below MIN_RESULTS.
    function recommend() {
      var exact = pool().sort(byFit);
      var shown = pickDistinct(exact, [], MAX_RESULTS);
      pickAny(exact, shown, MIN_RESULTS);
      var exactCount = shown.length;
      if (shown.length < MIN_RESULTS) {
        var near = products.filter(function (p) { return p.key === answers.use; }).sort(function (a, b) {
          return score(b) - score(a) || (a.late ? 1 : 0) - (b.late ? 1 : 0) || a.rank - b.rank;
        });
        pickDistinct(near, shown, MIN_RESULTS);
        pickAny(near, shown, MIN_RESULTS);
      }
      return { items: shown, near: shown.length > exactCount };
    }

    // Why this frame: its shape, and that it suits the face when it does.
    function reason(p) {
      var parts = [];
      var shapes = text.shapes || {};
      var name = Object.keys(p.shape).filter(function (k) { return shapes[k]; })[0];
      var picked = answers.shape && answers.shape !== 'any' ? answers.shape : name;
      if (picked && shapes[picked]) parts.push(shapes[picked]);
      if (faceAnswer() && suits(p, faceAnswer())) parts.push(text.fits);
      return parts.join(' · ');
    }

    function card(p) {
      var a = document.createElement('a');
      a.className = 'eyk-finder__card';
      a.href = p.url;

      var box = document.createElement('span');
      box.className = 'eyk-finder__img';
      var img = document.createElement('img');
      img.src = p.image;
      img.srcset = [300, 450, 600, 800].map(function (w) {
        return p.image.replace(/width=\d+/, 'width=' + w).replace(/height=\d+/, 'height=' + w) + ' ' + w + 'w';
      }).join(', ');
      img.sizes = '(min-width: 750px) 30vw, 50vw';
      img.width = 600;
      img.height = 600;
      img.alt = p.title;
      img.decoding = 'async';
      box.appendChild(img);
      a.appendChild(box);

      var name = document.createElement('span');
      name.className = 'eyk-finder__name';
      name.textContent = p.title;
      a.appendChild(name);

      var why = reason(p);
      if (why) {
        var note = document.createElement('span');
        note.className = 'eyk-finder__why';
        note.textContent = why;
        a.appendChild(note);
      }

      var view = document.createElement('span');
      view.className = 'eyk-finder__view';
      view.textContent = text.view || '';
      a.appendChild(view);
      return a;
    }

    function setAll(key) {
      var link = all[key] || all.any;
      if (!link) return;
      allLink.href = link.url;
      allLink.textContent = link.label;
    }

    function showResults(moveFocus) {
      var r = recommend();
      if (intro) intro.hidden = true;
      quiz.hidden = true;
      res.hidden = false;
      grid.textContent = '';
      grid.dataset.n = r.items.length;
      r.items.forEach(function (p) { grid.appendChild(card(p)); });
      lead.textContent = r.near ? text.near : text.exact;
      report('result');
      setAll(answers.use);
      save();
      if (moveFocus) focusAndReveal(res);
    }

    function showNothing() {
      quiz.hidden = true;
      res.hidden = false;
      grid.textContent = '';
      root.querySelector('[data-eyk-res-title]').hidden = true;
      lead.textContent = text.none || '';
      setAll('any');
      restart.hidden = true;
    }

    function save() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ a: answers, p: path })); } catch (e) {}
    }

    function clearSaved() {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    }

    // Which answers people give and where they stop, to test the women/men route. No personal data.
    function report(name, extra) {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var data = { use: answers.use, who: answers.who, step: name };
          Object.keys(extra || {}).forEach(function (k) { data[k] = extra[k]; });
          Shopify.analytics.publish('eyk_finder', data);
        }
      } catch (e) {}
    }

    function answer(q, v) {
      answers[q] = v;
      report('answer', { question: q, value: v });
      // A changed answer invalidates everything that came after it.
      var at = path.indexOf(q);
      if (at > -1) {
        path.slice(at + 1).forEach(function (later) { delete answers[later]; });
        path = path.slice(0, at + 1);
      } else {
        path.push(q);
      }
      var next = nextQuestion(pool(), q);
      if (next) {
        showQuestion(next, true);
      } else {
        showResults(true);
      }
    }

    function goBack() {
      // Reopen the previous question with its choice still marked; whatever came after it is dropped.
      var at = path.indexOf(currentQ);
      var prevAt = (at > -1 ? at : path.length) - 1;
      if (prevAt < 0) {
        showQuestion('use', true);
        return;
      }
      path.slice(prevAt + 1).forEach(function (later) { delete answers[later]; });
      path = path.slice(0, prevAt + 1);
      showQuestion(path[prevAt], true);
    }

    [].forEach.call(quiz.querySelectorAll('[data-q]'), function (s) {
      s.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-v]') : null;
        if (b) answer(s.dataset.q, b.dataset.v);
      });
    });
    back.addEventListener('click', goBack);
    restart.addEventListener('click', function () {
      answers = {};
      path = [];
      clearSaved();
      showQuestion('use', true);
    });

    if (!products.length) {
      showNothing();
      return;
    }

    // Coming back from a product page: keep the selection instead of asking everything again.
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (stored && stored.a && stored.a.use && Array.isArray(stored.p) &&
        products.some(function (p) { return p.key === stored.a.use; })) {
      answers = stored.a;
      path = stored.p;
      showResults(false);
      return;
    }
    showQuestion('use', false);
  }

  function start() {
    [].forEach.call(document.querySelectorAll('[data-eyk-finder]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
